import { render, staticRenderFns } from "./UserResultViewableRangeList.vue?vue&type=template&id=117210c2&"
import script from "./UserResultViewableRangeList.vue?vue&type=script&lang=ts&"
export * from "./UserResultViewableRangeList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports